<div class="crud-item-page">
  <form [formGroup]="form">
    <div class="crud-item-section">

      <span>
        <mat-form-field matTooltip="Firearm Assignment Id"
          [matTooltipDisabled]="disabledTooltip(this.firearmAssignmentId)">
          <mat-label i18n="@@type.FirearmAssignment.firearmAssignmentId">Firearm Assignment Id</mat-label>
          <input matInput formControlName="firearmAssignmentId" id="firearmAssignmentId"
            (ngModelChange)="firearmAssignmentIdChanging($event)" [(ngModel)]="item.firearmAssignmentId"
            (ngModelChange)="firearmAssignmentIdChanged($event)" #firearmAssignmentId type="number"
            placeholder="Firearm Assignment Id">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Select a Firearm Assignment Type from the list"
          [matTooltipDisabled]="disabledTooltip(this.firearmAssignmentType)">
          <mat-label i18n="@@type.FirearmAssignment.firearmAssignmentType">Firearm Assignment Type</mat-label>
          <mat-select formControlName="firearmAssignmentType" id="firearmAssignmentType"
            (ngModelChange)="firearmAssignmentTypeChanging($event)" [(ngModel)]="item.firearmAssignmentType"
            (ngModelChange)="firearmAssignmentTypeChanged($event)" #firearmAssignmentType
            placeholder="Firearm Assignment Type">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let firearmAssignmentType of firearmAssignmentTypeSelectionList"
              [value]="firearmAssignmentType.code">
              {{firearmAssignmentType.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Select a Storage Type from the list"
          [matTooltipDisabled]="disabledTooltip(this.storageType)">
          <mat-label i18n="@@type.FirearmAssignment.storageType">Storage Type</mat-label>
          <mat-select formControlName="storageType" id="storageType" (ngModelChange)="storageTypeChanging($event)"
            [(ngModel)]="item.storageType" (ngModelChange)="storageTypeChanged($event)" #storageType
            placeholder="Storage Type">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let storageType of storageTypeSelectionList" [value]="storageType.code">
              {{storageType.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Select a Lifecycle State from the list"
          [matTooltipDisabled]="disabledTooltip(this.lifecycleState)">
          <mat-label i18n="@@type.FirearmAssignment.lifecycleState">Lifecycle State</mat-label>
          <mat-select formControlName="lifecycleState" id="lifecycleState" [ngModel]="item.lifecycleState"
            #lifecycleState placeholder="Lifecycle State" [disabled]="true">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let lifecycleState of lifecycleStateSelectionList" [value]="lifecycleState.code">
              {{lifecycleState.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Select a Firearm from the list"
          [matTooltipDisabled]="disabledTooltip(this.firearm)">
          <mat-label i18n="@@type.FirearmAssignment.firearm">Firearm</mat-label>
          <mat-select formControlName="firearm" id="firearm" (ngModelChange)="firearmChanging($event)"
            [(ngModel)]="item.firearm" (ngModelChange)="firearmChanged($event)" #firearm placeholder="Firearm"
            [compareWith]="firearmCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let firearm of firearmSelectionList" [value]="firearm">
              {{firearmDisplay(firearm)}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

      <span>
        <span>
          <mat-slide-toggle floatLabel="always" appearance="none" color="primary" formControlName="currentAssignment"
            id="currentAssignment" [ngModel]="item.currentAssignment" #currentAssignment [disabled]="true" disabled
            i18n="@@type.FirearmAssignment.currentAssignment">
            Current Assignment </mat-slide-toggle>
        </span>
      </span>


      <span>
        <mat-form-field matTooltip="Select a Next Action from the list"
          [matTooltipDisabled]="disabledTooltip(this.nextAction)">
          <mat-label i18n="@@type.FirearmAssignment.nextAction">Next Action</mat-label>
          <mat-select formControlName="nextAction" id="nextAction" [ngModel]="item.nextAction" #nextAction
            placeholder="Next Action" [disabled]="true">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let nextAction of nextActionSelectionList" [value]="nextAction.code">
              {{nextAction.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

      <span>
        <span>
          <mat-slide-toggle floatLabel="always" appearance="none" color="primary" formControlName="actionPending"
            id="actionPending" [ngModel]="item.actionPending" #actionPending [disabled]="true" disabled
            i18n="@@type.FirearmAssignment.actionPending">
            Action Pending </mat-slide-toggle>
        </span>
      </span>
    </div>
    <mat-divider></mat-divider>

    <div class="crud-item-section">

      <span>
        <mat-form-field matTooltip="Email" [matTooltipDisabled]="disabledTooltip(this.personEmail)">
          <mat-label i18n="@@type.FirearmAssignment.personEmail">Email</mat-label>
          <input matInput formControlName="personEmail" id="personEmail" (ngModelChange)="personEmailChanging($event)"
            [(ngModel)]="item.personEmail" (ngModelChange)="personEmailChanged($event)" #personEmail maxlength="255"
            placeholder="Email">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Select a Ranger from the list" [matTooltipDisabled]="disabledTooltip(this.ranger)">
          <mat-label i18n="@@type.FirearmAssignment.ranger">Ranger</mat-label>
          <mat-select formControlName="ranger" id="ranger" (ngModelChange)="rangerChanging($event)"
            [(ngModel)]="item.ranger" (ngModelChange)="rangerChanged($event)" #ranger placeholder="Ranger"
            [compareWith]="rangerCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let ranger of rangerSelectionList" [value]="ranger">
              {{rangerDisplay(ranger)}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Select a User from the list" [matTooltipDisabled]="disabledTooltip(this.user)">
          <mat-label i18n="@@type.FirearmAssignment.user">User</mat-label>
          <mat-select formControlName="user" id="user" (ngModelChange)="userChanging($event)" [(ngModel)]="item.user"
            (ngModelChange)="userChanged($event)" #user placeholder="User" [compareWith]="userCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let user of userSelectionList" [value]="user">
              {{userDisplay(user)}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Select a Location from the list"
          [matTooltipDisabled]="disabledTooltip(this.location)" class="crud-item-input-wider">
          <mat-label i18n="@@type.FirearmAssignment.location">Location</mat-label>
          <mat-select formControlName="location" id="location" (ngModelChange)="locationChanging($event)"
            [(ngModel)]="item.location" (ngModelChange)="locationChanged($event)" #location placeholder="Location"
            [compareWith]="locationCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let location of locationSelectionList" [value]="location">
              {{locationDisplay(location)}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

      <span>
        <span>
          <mat-slide-toggle floatLabel="always" appearance="none" color="primary"
              formControlName="personalFirearmAssignment" id="personalFirearmAssignment"              
              (ngModelChange)="personalFirearmAssignmentChanging($event)" [(ngModel)]="item.personalFirearmAssignment"              
              (ngModelChange)="personalFirearmAssignmentChanged($event)" #personalFirearmAssignment i18n="@@type.FirearmAssignment.personalFirearmAssignment">
              Personal Firearm Assignment          
          </mat-slide-toggle>        
        </span>
      </span>
    </div>
    <mat-divider></mat-divider>

    <div class="crud-item-section">

      <span>
       
      </span>
    </div>
    <mat-divider></mat-divider>


    <div class="crud-item-section">

      <span>
        <mat-form-field matTooltip="Started By" [matTooltipDisabled]="disabledTooltip(this.startedBy)">
          <mat-label i18n="@@type.FirearmAssignment.startedBy">Started By</mat-label>
          <input matInput formControlName="startedBy" id="startedBy" (ngModelChange)="startedByChanging($event)"
            [(ngModel)]="item.startedBy" (ngModelChange)="startedByChanged($event)" #startedBy maxlength="255"
            placeholder="Started By">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Start Date" [matTooltipDisabled]="disabledTooltip(this.startDate)">
          <mat-label i18n="@@type.FirearmAssignment.startDate">Start Date</mat-label>
          <input matInput formControlName="startDate" id="startDate" (ngModelChange)="startDateChanging($event)"
            [(ngModel)]="item.startDate" (ngModelChange)="startDateChanged($event)" #startDate
            [matDatetimepicker]="startDateDatetimepicker" placeholder="Start Date">
          <mat-datetimepicker-toggle matSuffix [for]="startDateDatetimepicker"></mat-datetimepicker-toggle>
          <mat-datetimepicker #startDateDatetimepicker color="primary" type="datetime"></mat-datetimepicker>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Handover Acknowledged By"
          [matTooltipDisabled]="disabledTooltip(this.handoverAcknowledgedBy)">
          <mat-label i18n="@@type.FirearmAssignment.handoverAcknowledgedBy">Handover Acknowledged By</mat-label>
          <input matInput formControlName="handoverAcknowledgedBy" id="handoverAcknowledgedBy"
            (ngModelChange)="handoverAcknowledgedByChanging($event)" [(ngModel)]="item.handoverAcknowledgedBy"
            (ngModelChange)="handoverAcknowledgedByChanged($event)" #handoverAcknowledgedBy maxlength="255"
            placeholder="Handover Acknowledged By">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Handover Acknowledged Date"
          [matTooltipDisabled]="disabledTooltip(this.handoverAcknowledgedDate)">
          <mat-label i18n="@@type.FirearmAssignment.handoverAcknowledgedDate">Handover Acknowledged Date</mat-label>
          <input matInput formControlName="handoverAcknowledgedDate" id="handoverAcknowledgedDate"
            (ngModelChange)="handoverAcknowledgedDateChanging($event)" [(ngModel)]="item.handoverAcknowledgedDate"
            (ngModelChange)="handoverAcknowledgedDateChanged($event)" #handoverAcknowledgedDate
            [matDatetimepicker]="handoverAcknowledgedDateDatetimepicker" placeholder="Handover Acknowledged Date">
          <mat-datetimepicker-toggle matSuffix [for]="handoverAcknowledgedDateDatetimepicker"></mat-datetimepicker-toggle>
          <mat-datetimepicker #handoverAcknowledgedDateDatetimepicker color="primary" type="datetime"></mat-datetimepicker>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="End Date" [matTooltipDisabled]="disabledTooltip(this.endDate)">
          <mat-label i18n="@@type.FirearmAssignment.endDate">End Date</mat-label>
          <input matInput formControlName="endDate" id="endDate" [ngModel]="item.endDate" #endDate
            [matDatetimepicker]="endDateDatetimepicker" placeholder="End Date" disabled>
          <mat-datetimepicker-toggle matSuffix [for]="endDateDatetimepicker"></mat-datetimepicker-toggle>
          <mat-datetimepicker #endDateDatetimepicker color="primary" type="datetime"></mat-datetimepicker>
        </mat-form-field>
      </span>

    </div>
    <mat-divider></mat-divider>

    <div class="crud-item-section">

      <span>
        <span>
          <mat-slide-toggle floatLabel="always" appearance="none" color="primary" formControlName="notifyPolice"
            id="notifyPolice" (ngModelChange)="notifyPoliceChanging($event)" [(ngModel)]="item.notifyPolice"
            (ngModelChange)="notifyPoliceChanged($event)" #notifyPolice i18n="@@type.FirearmAssignment.notifyPolice">
            Notify Police </mat-slide-toggle>
        </span>
      </span>

      <span>
        <mat-form-field matTooltip="Police Notified Date"
          [matTooltipDisabled]="disabledTooltip(this.policeNotifiedDate)">
          <mat-label i18n="@@type.FirearmAssignment.policeNotifiedDate">Police Notified Date</mat-label>
          <input matInput formControlName="policeNotifiedDate" id="policeNotifiedDate"
            (ngModelChange)="policeNotifiedDateChanging($event)" [(ngModel)]="item.policeNotifiedDate"
            (ngModelChange)="policeNotifiedDateChanged($event)" #policeNotifiedDate
            [matDatetimepicker]="policeNotifiedDateDatetimePicker" placeholder="Police Notified Date">
          <mat-datetimepicker-toggle matSuffix [for]="policeNotifiedDateDatetimePicker"></mat-datetimepicker-toggle>
          <mat-datetimepicker #policeNotifiedDateDatetimePicker color="primary" type="datetime"></mat-datetimepicker>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Police Notification Reason"
          [matTooltipDisabled]="disabledTooltip(this.policeNotificationReason)" class="crud-item-input-wide">
          <mat-label i18n="@@type.FirearmAssignment.policeNotificationReason">Police Notification Reason / Comments</mat-label>
          <textarea matInput formControlName="policeNotificationReason" id="policeNotificationReason"
            (ngModelChange)="policeNotificationReasonChanging($event)" [(ngModel)]="item.policeNotificationReason"
            (ngModelChange)="policeNotificationReasonChanged($event)" #policeNotificationReason maxlength="2000"
            placeholder="Police Notification Reason / Comments"></textarea>
        </mat-form-field>
      </span>

    </div>
    <mat-divider></mat-divider>

    <div class="crud-item-section">


      <span>
        <span>
          <mat-slide-toggle floatLabel="always" appearance="none" color="primary" formControlName="buApproved"
            id="buApproved" (ngModelChange)="buApprovedChanging($event)" [(ngModel)]="item.buApproved"
            (ngModelChange)="buApprovedChanged($event)" #buApproved i18n="@@type.FirearmAssignment.buApproved">
            Bu Approved </mat-slide-toggle>
        </span>
      </span>

      <span>
        <mat-form-field matTooltip="Bu Approved Rejected By"
          [matTooltipDisabled]="disabledTooltip(this.buApprovedRejectedBy)">
          <mat-label i18n="@@type.FirearmAssignment.buApprovedRejectedBy">Bu Approved Rejected By</mat-label>
          <input matInput formControlName="buApprovedRejectedBy" id="buApprovedRejectedBy"
            (ngModelChange)="buApprovedRejectedByChanging($event)" [(ngModel)]="item.buApprovedRejectedBy"
            (ngModelChange)="buApprovedRejectedByChanged($event)" #buApprovedRejectedBy maxlength="255"
            placeholder="Bu Approved Rejected By">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Bu Approved Rejected Date"
          [matTooltipDisabled]="disabledTooltip(this.buApprovedRejectedDate)">
          <mat-label i18n="@@type.FirearmAssignment.buApprovedRejectedDate">Bu Approved Rejected Date</mat-label>
          <input matInput formControlName="buApprovedRejectedDate" id="buApprovedRejectedDate"
            (ngModelChange)="buApprovedRejectedDateChanging($event)" [(ngModel)]="item.buApprovedRejectedDate"
            (ngModelChange)="buApprovedRejectedDateChanged($event)" #buApprovedRejectedDate
            [matDatetimepicker]="buApprovedRejectedDateDatetimepicker" placeholder="Bu Approved Rejected Date">
          <mat-datetimepicker-toggle matSuffix [for]="buApprovedRejectedDateDatetimepicker"></mat-datetimepicker-toggle>
          <mat-datetimepicker #buApprovedRejectedDateDatetimepicker color="primary" type="datetime"></mat-datetimepicker>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Bu Approval Rejection Reason"
          [matTooltipDisabled]="disabledTooltip(this.buApprovalRejectionReason)" class="crud-item-input-wide">
          <mat-label i18n="@@type.FirearmAssignment.buApprovalRejectionReason">Bu Approval Rejection Reason</mat-label>
          <input matInput formControlName="buApprovalRejectionReason" id="buApprovalRejectionReason"
            (ngModelChange)="buApprovalRejectionReasonChanging($event)" [(ngModel)]="item.buApprovalRejectionReason"
            (ngModelChange)="buApprovalRejectionReasonChanged($event)" #buApprovalRejectionReason maxlength="1000"
            placeholder="Bu Approval Rejection Reason">
        </mat-form-field>
      </span>
    </div>
    <mat-divider></mat-divider>

    <div class="crud-item-section">
      <span>
        <span>
          <mat-slide-toggle floatLabel="always" appearance="none" color="primary" formControlName="leadApproved"
            id="leadApproved" (ngModelChange)="leadApprovedChanging($event)" [(ngModel)]="item.leadApproved"
            (ngModelChange)="leadApprovedChanged($event)" #leadApproved i18n="@@type.FirearmAssignment.leadApproved">
            Lead Approved </mat-slide-toggle>
        </span>
      </span>

      <span>
        <mat-form-field matTooltip="Lead Approved Rejected By"
          [matTooltipDisabled]="disabledTooltip(this.leadApprovedRejectedBy)">
          <mat-label i18n="@@type.FirearmAssignment.leadApprovedRejectedBy">Lead Approved Rejected By</mat-label>
          <input matInput formControlName="leadApprovedRejectedBy" id="leadApprovedRejectedBy"
            (ngModelChange)="leadApprovedRejectedByChanging($event)" [(ngModel)]="item.leadApprovedRejectedBy"
            (ngModelChange)="leadApprovedRejectedByChanged($event)" #leadApprovedRejectedBy maxlength="255"
            placeholder="Lead Approved Rejected By">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Lead Approved Rejected Date"
          [matTooltipDisabled]="disabledTooltip(this.leadApprovedRejectedDate)">
          <mat-label i18n="@@type.FirearmAssignment.leadApprovedRejectedDate">Lead Approved Rejected Date</mat-label>
          <input matInput formControlName="leadApprovedRejectedDate" id="leadApprovedRejectedDate"
            (ngModelChange)="leadApprovedRejectedDateChanging($event)" [(ngModel)]="item.leadApprovedRejectedDate"
            (ngModelChange)="leadApprovedRejectedDateChanged($event)" #leadApprovedRejectedDate
            [matDatetimepicker]="leadApprovedRejectedDateDatetimepicker" placeholder="Lead Approved Rejected Date">
          <mat-datetimepicker-toggle matSuffix [for]="leadApprovedRejectedDateDatetimepicker"></mat-datetimepicker-toggle>
          <mat-datetimepicker #leadApprovedRejectedDateDatetimepicker color="primary" type="datetime"></mat-datetimepicker>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Lead Approval Rejection Reason"
          [matTooltipDisabled]="disabledTooltip(this.leadApprovalRejectionReason)" class="crud-item-input-wide">
          <mat-label i18n="@@type.FirearmAssignment.leadApprovalRejectionReason">Lead Approval Rejection
            Reason</mat-label>
          <input matInput formControlName="leadApprovalRejectionReason" id="leadApprovalRejectionReason"
            (ngModelChange)="leadApprovalRejectionReasonChanging($event)" [(ngModel)]="item.leadApprovalRejectionReason"
            (ngModelChange)="leadApprovalRejectionReasonChanged($event)" #leadApprovalRejectionReason maxlength="1000"
            placeholder="Lead Approval Rejection Reason">
        </mat-form-field>
      </span>


    </div>
    <mat-divider></mat-divider>

    <div class="crud-item-section">

      <span>
        <mat-form-field matTooltip="Activated By" [matTooltipDisabled]="disabledTooltip(this.activatedBy)">
          <mat-label i18n="@@type.FirearmAssignment.activatedBy">Activated By</mat-label>
          <input matInput formControlName="activatedBy" id="activatedBy" (ngModelChange)="activatedByChanging($event)"
            [(ngModel)]="item.activatedBy" (ngModelChange)="activatedByChanged($event)" #activatedBy maxlength="255"
            placeholder="Activated By">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Activated Date" [matTooltipDisabled]="disabledTooltip(this.activatedDate)">
          <mat-label i18n="@@type.FirearmAssignment.activatedDate">Activated Date</mat-label>
          <input matInput formControlName="activatedDate" id="activatedDate"
            (ngModelChange)="activatedDateChanging($event)" [(ngModel)]="item.activatedDate"
            (ngModelChange)="activatedDateChanged($event)" #activatedDate [matDatetimepicker]="activatedDateDatetimepicker"
            placeholder="Activated Date">
          <mat-datetimepicker-toggle matSuffix [for]="activatedDateDatetimepicker"></mat-datetimepicker-toggle>
          <mat-datetimepicker #activatedDateDatetimepicker color="primary" type="datetime"></mat-datetimepicker>
        </mat-form-field>
      </span>

    </div>
    <mat-divider></mat-divider>

    <div class="crud-item-section">


      <span>
        <mat-form-field matTooltip="Canceled By" [matTooltipDisabled]="disabledTooltip(this.canceledBy)">
          <mat-label i18n="@@type.FirearmAssignment.canceledBy">Canceled By</mat-label>
          <input matInput formControlName="canceledBy" id="canceledBy" (ngModelChange)="canceledByChanging($event)"
            [(ngModel)]="item.canceledBy" (ngModelChange)="canceledByChanged($event)" #canceledBy maxlength="255"
            placeholder="Canceled By">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Canceled Date" [matTooltipDisabled]="disabledTooltip(this.canceledDate)">
          <mat-label i18n="@@type.FirearmAssignment.canceledDate">Canceled Date</mat-label>
          <input matInput formControlName="canceledDate" id="canceledDate"
            (ngModelChange)="canceledDateChanging($event)" [(ngModel)]="item.canceledDate"
            (ngModelChange)="canceledDateChanged($event)" #canceledDate [matDatetimepicker]="canceledDateDatetimepicker"
            placeholder="Canceled Date">
          <mat-datetimepicker-toggle matSuffix [for]="canceledDateDatetimepicker"></mat-datetimepicker-toggle>
          <mat-datetimepicker #canceledDateDatetimepicker color="primary" type="datetime"></mat-datetimepicker>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Canceled Reason" [matTooltipDisabled]="disabledTooltip(this.canceledReason)"
          class="crud-item-input-wide">
          <mat-label i18n="@@type.FirearmAssignment.canceledReason">Canceled Reason</mat-label>
          <input matInput formControlName="canceledReason" id="canceledReason"
            (ngModelChange)="canceledReasonChanging($event)" [(ngModel)]="item.canceledReason"
            (ngModelChange)="canceledReasonChanged($event)" #canceledReason maxlength="1000"
            placeholder="Canceled Reason">
        </mat-form-field>
      </span>

    </div>
    <mat-divider></mat-divider>

    <div class="crud-item-section">

      <span>
        <mat-form-field matTooltip="Created By" [matTooltipDisabled]="disabledTooltip(this.createdBy)">
          <mat-label i18n="@@type.FirearmAssignment.createdBy">Created By</mat-label>
          <input matInput formControlName="createdBy" id="createdBy" (ngModelChange)="createdByChanging($event)"
            [(ngModel)]="item.createdBy" (ngModelChange)="createdByChanged($event)" #createdBy maxlength="255"
            placeholder="Created By">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Created Date" [matTooltipDisabled]="disabledTooltip(this.createdDate)">
          <mat-label i18n="@@type.FirearmAssignment.createdDate">Created Date</mat-label>
          <input matInput formControlName="createdDate" id="createdDate" (ngModelChange)="createdDateChanging($event)"
            [(ngModel)]="item.createdDate" (ngModelChange)="createdDateChanged($event)" #createdDate
            [matDatetimepicker]="createdDateDatetimepicker" placeholder="Created Date">
          <mat-datetimepicker-toggle matSuffix [for]="createdDateDatetimepicker"></mat-datetimepicker-toggle>
          <mat-datetimepicker #createdDateDatetimepicker color="primary" type="datetime"></mat-datetimepicker>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Updated By" [matTooltipDisabled]="disabledTooltip(this.updatedBy)">
          <mat-label i18n="@@type.FirearmAssignment.updatedBy">Updated By</mat-label>
          <input matInput formControlName="updatedBy" id="updatedBy" (ngModelChange)="updatedByChanging($event)"
            [(ngModel)]="item.updatedBy" (ngModelChange)="updatedByChanged($event)" #updatedBy maxlength="255"
            placeholder="Updated By">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Updated Date" [matTooltipDisabled]="disabledTooltip(this.updatedDate)">
          <mat-label i18n="@@type.FirearmAssignment.updatedDate">Updated Date</mat-label>
          <input matInput formControlName="updatedDate" id="updatedDate" (ngModelChange)="updatedDateChanging($event)"
            [(ngModel)]="item.updatedDate" (ngModelChange)="updatedDateChanged($event)" #updatedDate
            [matDatetimepicker]="updatedDateDatetimepicker" placeholder="Updated Date">
          <mat-datetimepicker-toggle matSuffix [for]="updatedDateDatetimepicker"></mat-datetimepicker-toggle>
          <mat-datetimepicker #updatedDateDatetimepicker color="primary" type="datetime"></mat-datetimepicker>
        </mat-form-field>
      </span>

    </div>
    <mat-divider></mat-divider>

  </form>
</div>
